import {Chip} from "@mui/material";
import {statusColors, statusLabels} from "../constants";

export const CallStatusChip = ({status}) => {
  return (
    <Chip
      size="small"
      color={statusColors[status] || "default"}
      variant={status === "NOT_CALLED" ? "outlined" : "filled"}
      label={statusLabels[status] || status || "-"}
    />
  )
}
